import React from 'react';
export const MembershipsAnalytics = () => {
    return React.createElement("p", null, "memberships analytics");
};
